import PrimeReact from "primereact/api"
import { Button } from "primereact/button"
import { Calendar } from 'primereact/calendar'
import { Card } from "primereact/card"
import { ConfirmDialog } from "primereact/confirmdialog"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { Toast } from 'primereact/toast'
import { classNames } from "primereact/utils"
import { useEffect, useRef, useState } from "react"
import { Field, Form } from "react-final-form"
import { connect, useDispatch } from "react-redux"
import { GetUserStatus } from "../../../../../AdminPortal/scenes/User/enums"
import { SingpassUserDetails } from "../../../../../AdminPortal/scenes/User/interfaces"
import { LOOKUPS_KEY, RESUME_KEY } from "../../../../../constants/localStorageKeys"
import { Resume } from '../../interface'
import FileReuploader from "../FileReuploader/FileReuploader"
import { Nullable } from "primereact/ts-helpers"
import { Chips } from "primereact/chips"
import { MultiSelect } from "primereact/multiselect"
import { CategoryEnum } from "../../../../../AdminPortal/scenes/Lookup/enums"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import DatatableItem from "../../../../../constants/helpers/DatatableItem"
import { AppDispatch } from "../../../../../store"
import { retrieveLookupByCategories } from "../../../../../AdminPortal/scenes/Lookup/LookupAction"
import { Fieldset } from "primereact/fieldset"
import { useLookupOptions } from "../../../../../constants/helpers/useLookupOptions"
import FieldChange from "../../../../../utils/FieldChange"

interface ApplicationFormProps {
  formHeader: string
  actionOnSubmit: any
  submitButtonLabel: string
  resettable?: boolean
  resume?: Resume
  uploadResume: (resumeData: FormData) => any

  // singpassUserDetails: SingpassUserDetails
  // singpassUserDetailsStatus: GetUserStatus
  // getSingpassUserDetails: (code: string, state: number) => {}
}

const ApplicationForm = (props: ApplicationFormProps) => {
  const { formHeader, actionOnSubmit, submitButtonLabel, resettable = true, resume, uploadResume } = props
  
  PrimeReact.ripple = true
  const toast = useRef<any>(null)
  const dispatch = useDispatch<AppDispatch>()

  // primefaces custom input component
  const [currentSalary, setCurrentSalary] = useState<number>(0)
  const [expectedSalary, setExpectedSalary] = useState<number>(0)
  const [yearsOfExp, setYearsOfExp] = useState<number>(0)
  const [dob, setDob] = useState<Date>(new Date());
  const [availStartDate, setAvailStartDate] = useState<Date>(new Date());

  const [displayConfirmationDialog, setDisplayConfirmationDialog] = useState(false)
  const [retrievingFromSingpass, setRetrievingFromSingpass] = useState(false)
  const [payload, setPayload] = useState<Resume>()
  
  const { qualificationList, countryList, languageList, refreshLookups } = useLookupOptions()

  const [education, setEducation] = useState(resume?.education || [])
  const [workExperience, setWorkExperience] = useState(resume?.workExperience || [])
  const [socialLink, setSocialLink] = useState(resume?.socialLink || [])
  const [professionalCertificate, setProfessionalCertificate] = useState(resume?.professionalCertificate || [])

  const singpassUserDetails = {} as any

  const resumeDetails = {
    id: resume?.id || undefined,
    fullName: singpassUserDetails?.fullName || resume?.fullName || '',
    contactNumber: singpassUserDetails?.mobileNo || resume?.contactNumber || '',
    email: singpassUserDetails?.email || resume?.email || '',
    gender: singpassUserDetails?.sex || resume?.gender || '',
    dateOfBirth: new Date(singpassUserDetails?.dob || resume?.dateOfBirth || new Date()),
    nationality: singpassUserDetails?.nationality || resume?.nationality || '',
    residence: singpassUserDetails?.residence || resume?.residence || '',
    country: singpassUserDetails?.address || resume?.country || '',
    highestQualification: resume?.highestQualification || '',
    currentEmploymentStatus: resume?.currentEmploymentStatus || '',
    availStartDate: new Date(resume?.availStartDate || new Date()),
    currentSalary: resume?.currentSalary || 0,
    expectedSalary: resume?.expectedSalary || 0,
    totalYearsOfExperiences: resume?.totalYearsOfExperiences || 0,
    languageProficiency: resume?.languageProficiency || [],
    skills: resume?.skills || [],
    education: resume?.education || [],
    workExperience: resume?.workExperience || [],
    professionalCertificate: resume?.professionalCertificate || [],
    socialLink: resume?.socialLink || [],
  }
  const [initialValues, setInitialValues] = useState<Resume>(resumeDetails)

  useEffect(() => {
    if (qualificationList.length === 0 || 
      countryList.length === 0 || 
      languageList.length === 0) {
      // retrieve lookup if not exist
      dispatch(retrieveLookupByCategories([
        CategoryEnum.COUNTRY, 
        CategoryEnum.LANGUAGE, 
        CategoryEnum.QUALIFICATION]))
        .unwrap()
        .then(() => {
          refreshLookups()
        })
        .catch((error) => {
          // TODO find a way to show error
          console.log('error', error)
        })
    }
  }, [])

  useEffect(() => {
    // when resume updated, re-set initial value
    setInitialValues(resumeDetails)

    // set form fields
    setCurrentSalary(resumeDetails.currentSalary)
    setExpectedSalary(resumeDetails.expectedSalary)
    setYearsOfExp(resumeDetails.totalYearsOfExperiences)
    setDob(resumeDetails.dateOfBirth)
    setAvailStartDate(resumeDetails.availStartDate)
    setEducation(resumeDetails.education)
    setWorkExperience(resumeDetails.workExperience)
    setProfessionalCertificate(resumeDetails.professionalCertificate)
    setSocialLink(resumeDetails.socialLink)
  }, [resume])

  const validate = (data: any) => {
    let errors = {} as any

    if (!data.fullName) {
      errors.fullName = "Full Name is required."
    }
    if (!data.contactNumber) {
      errors.contactNumber = "Contact Number is required."
    }
    if (!data.email) {
      errors.email = "E-Mail is required."
    }
    else if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(data.email) !== true) {
      errors.email = "Please enter a valid E-Mail."
    }
    if (!data.gender) {
      errors.gender = "Gender is required."
    }
    if (!data.dateOfBirth) {
      errors.dateOfBirth = "Date of Birth is required."
    }
    if (!data.nationality) {
      errors.nationality = "Nationality is required."
    }
    if (!data.residence) {
      errors.residence = "Residence is required."
    }
    if (!data.country) {
      errors.country = "Country is required."
    }
    if (!data.highestQualification) {
      errors.highestQualification = "Qualification is required."
    }
    if (!data.currentEmploymentStatus) {
      errors.currentEmploymentStatus = "Current Employment Status is required."
    }
    if (!data.availStartDate) {
      errors.availStartDate = "Available Start Date is required."
    }
    if (!data.currentSalary && data.currentSalary !== 0) {
      errors.currentSalary = "Current Salary is required."
    }
    if (!data.expectedSalary && data.expectedSalary !== 0) {
      errors.expectedSalary = "Expected Salary is required."
    }
    if (!data.totalYearsOfExperiences && data.totalYearsOfExperiences !== 0) {
      errors.totalYearsOfExperiences = "Years of Experience is required."
    }

    if (!data.languageProficiency || data.languageProficiency.length === 0) {
      errors.languageProficiency = "Language Proficiency are required."
    }
    if (!data.skills || data.skills.length === 0) {
      errors.skills = "Please define at least one skill."
    }
    if (!data.education || data.education.length === 0) {
      errors.skills = "Please provide your education."
    }
    console.log('errors', errors)
    return errors;
  }

  const onSubmit = (data: any, form: any) => {
    let payload = {} as Resume

    payload.fullName = data.fullName
    payload.contactNumber = data.contactNumber
    payload.email = data.email
    payload.gender = data.gender
    payload.dateOfBirth = data.dateOfBirth
    payload.nationality = data.nationality
    payload.residence = data.residence
    payload.country = data.country
    payload.highestQualification = data.highestQualification
    payload.currentEmploymentStatus = data.currentEmploymentStatus
    payload.availStartDate = data.availStartDate
    payload.currentSalary = !!data.currentSalary.value ? data.currentSalary.value : currentSalary
    payload.expectedSalary = !!data.expectedSalary.value ? data.expectedSalary.value : expectedSalary
    payload.totalYearsOfExperiences = !!data.totalYearsOfExperiences.value ? data.totalYearsOfExperiences.value : yearsOfExp
    payload.languageProficiency = data.languageProficiency
    payload.skills = data.skills
    payload.education = education
    payload.workExperience = workExperience
    payload.professionalCertificate = professionalCertificate
    payload.socialLink = socialLink
    setPayload(payload)
    setDisplayConfirmationDialog(true)
    console.log('test')
  }

  const submitApplication = () => {
    actionOnSubmit(payload, localStorage.getItem(RESUME_KEY))
  }

  const handleReset = (form: any) => {
    form.restart()
    setAvailStartDate(new Date())
    setDob(new Date())
    setCurrentSalary(0)
    setExpectedSalary(0)
    setYearsOfExp(0)
    toast.current.show({ severity: 'info', summary: 'Form Reset', detail: 'Form details have been cleared', life: 3000 })
  }

  const isFormFieldValid = (meta: any) => !!(meta.touched && meta.error)
  const getFormErrorMessage = (meta: any) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
  }

  const monthNavigatorTemplate = (e: any) => {
    return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />
  }

  const yearNavigatorTemplate = (e: any) => {
    return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="ml-2" style={{ lineHeight: 1 }} />
  }

  const retrieveUsingSingpass = () => {
    const clientId = 'STG2-MYINFO-DEMO-APP'
    const callbackUrl = 'http://localhost:3001/callback'
    const scopes = 'partialuinfin,name,aliasname,sex,race,nationality,dob,email,mobileno,residentialstatus,regadd,edulevel,occupation'
    const baseAuthUrl = 'https://test.api.myinfo.gov.sg/com/v3/authorise'
    const appPurpose = 'demonstrating MyInfo APIs'
    const state = Math.floor(Math.random() * 100000)

    const singpassAuthWindow = window.open(`${baseAuthUrl}?client_id=${clientId}&attributes=${scopes}&purpose=${appPurpose}&state=${state}&redirect_uri=${callbackUrl}`)
    if (singpassAuthWindow != null) {
      const singPassAuthInterval = setInterval(() => {
        if (singpassAuthWindow.closed) {
          clearInterval(singPassAuthInterval)

          // retrive auth code and call api to retrieve details
          const authCode = localStorage.getItem('authCode')
          const authState = Number(localStorage.getItem('authState'))
          if (authCode !== null && authState !== null) {
            // remove from localstorage immediately
            localStorage.removeItem('authCode')
            localStorage.removeItem('authState')

            // check if credentials matches using state
            if (state === authState) {
              setRetrievingFromSingpass(true)

              // call endpoint to retrieve details
              // todo new dispatch
              // getSingpassUserDetails(authCode, authState)
            }
          }
        }
      }, 1000)
    }
  }

  // useEffect(() => {
  //   setDob(new Date(singpassUserDetails.dob))
  // }, [singpassUserDetails])

  return (
    <div>
      <ConfirmDialog header="Confirmation" message="Have you reviewed that your information are correct?" icon="pi pi-exclamation-triangle"
        visible={displayConfirmationDialog} onHide={() => setDisplayConfirmationDialog(false)} accept={submitApplication} reject={() => setDisplayConfirmationDialog(false)}>
      </ConfirmDialog>
      <Toast ref={toast} />
      <Card>
        <div className="flex lg:justify-content-start align-items-center">
          {resume ?
            <FileReuploader uploadResume={uploadResume} headerText={"Reupload your resume here"} /> : <></>}
        </div>
        <p>We have managed to infer the following information from the uploaded resume, please review and fill in the remaining information.</p>

        <Form
          onSubmit={onSubmit}
          initialValues={initialValues}
          validate={validate}
          render={({ form, handleSubmit, pristine }) => (
            <form onSubmit={handleSubmit}>
              <div className="flex formgrid grid">
                <div className="col-12 mb-3">
                  <Fieldset legend="Personal Details">
                    <div className="grid">
                      <div className="field col-6 p-mb-3">
                        <strong>Full Name: </strong>
                        <Field name="fullName">
                          {({ input, meta }) => (
                            <div>
                              <InputText {...input} type="text" className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Contact Number: </strong>
                        <Field name="contactNumber">
                          {({ input, meta }) => (
                            <div>
                              <InputText {...input} type="text" className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>E-Mail: </strong>
                        <Field name="email">
                          {({ input, meta }) => (
                            <div>
                              <InputText {...input} type="email" className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Gender: </strong>
                        <Field name="gender">
                          {({ input, meta }) => (
                            <div>
                              <Dropdown {...input} options={["Male", "Female"]} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Date of Birth: </strong>
                        <Field name="dateOfBirth">
                          {({ input, meta }) => (
                            <div>
                              <Calendar
                                {...input}
                                value={dob}
                                onChange={(e) => {
                                  setDob(e.value || new Date());
                                  input.onChange(e.value);
                                }}
                                dateFormat="yy-mm-dd"
                                yearRange="1950:2025"
                                className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                              />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Nationality: </strong>
                        <Field name="nationality">
                          {({ input, meta }) => (
                            <div>
                              <InputText {...input} type="text" className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Residence: </strong>
                        <Field name="residence">
                          {({ input, meta }) => (
                            <div>
                              <Dropdown {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={countryList} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Country: </strong>
                        <Field name="country">
                          {({ input, meta }) => (
                            <div>
                              <Dropdown {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={countryList} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Highest Qualification: </strong>
                        <Field name="highestQualification">
                          {({ input, meta }) => (
                            <div>
                              <Dropdown {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={qualificationList} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Current Employment Status: </strong>
                        <Field name="currentEmploymentStatus">
                          {({ input, meta }) => (
                            <div>
                              <Dropdown {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={["Full-Time Employment", "Part-Time Employment", "Self Employed", "Unemployed", "Student"]} />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Availability: </strong>
                        <Field name="availStartDate">
                          {({ input, meta }) => (
                            <div>
                              <Calendar
                                {...input}
                                value={availStartDate}
                                onChange={(e) => {
                                  setAvailStartDate(e.value || new Date());
                                  input.onChange(e.value);
                                }}
                                dateFormat="yy-mm-dd"
                                yearRange={`${new Date().getFullYear()}:2030`}
                                className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                              />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Current Salary: </strong>
                        <Field name="currentSalary">
                          {({ input, meta }) => (
                            <div>
                              <InputNumber
                                {...input}
                                value={currentSalary}
                                prefix="$"
                                mode="currency"
                                currency="SGD"
                                min={0}
                                className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                onChange={(e) => FieldChange(setCurrentSalary, input, e.value || 0)}
                                onValueChange={(e) => FieldChange(setCurrentSalary, input, e.value || 0)}
                              />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Expected Salary: </strong>
                        <Field name="expectedSalary">
                          {({ input, meta }) => (
                            <div>
                              <InputNumber
                                {...input}
                                value={expectedSalary}
                                prefix="$"
                                mode="currency"
                                currency="SGD"
                                min={0}
                                className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                onChange={(e) => FieldChange(setExpectedSalary, input, e.value || 0)}
                                onValueChange={(e) => FieldChange(setExpectedSalary, input, e.value || 0)}
                              />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Years of Experience: </strong>
                        <Field name="totalYearsOfExperiences">
                          {({ input, meta }) => (
                            <div>
                              <InputNumber
                                {...input}
                                value={yearsOfExp}
                                suffix=" year(s)"
                                min={0}
                                max={100}
                                className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })}
                                onChange={(e) => FieldChange(setYearsOfExp, input, e.value || 0)}
                                onValueChange={(e) => FieldChange(setYearsOfExp, input, e.value || 0)}
                              />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Skills: </strong>
                        <Field name="skills">
                          {({ input, meta }) => (
                            <div>
                              <Chips {...input} className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} separator="," />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                      <div className="field col-6 p-mb-3">
                        <strong>Language Proficiency: </strong>
                        <Field name="languageProficiency">
                          {({ input, meta }) => (
                            <div>
                              <MultiSelect {...input} filter className={classNames("inputfield w-full", { 'p-error': isFormFieldValid(meta) })} options={languageList} showClear placeholder="Select Language(s)" />
                              {getFormErrorMessage(meta)}
                            </div>
                          )}
                        </Field>
                      </div>
                    </div>
                  </Fieldset>
                </div>
                <div className="col-12 mb-3">
                  <Fieldset legend="Education">
                    <div className="field m-0">
                      <DatatableItem
                        data={education}
                        setData={setEducation}
                        fields={{
                          courseTitle: 'Course Title',
                          educationLevel: 'Education Level',
                          institutionName: 'Institution Name',
                          numberOfYears: 'No. of Years'
                        }}
                        className="inputfield w-full"
                      />
                    </div>
                  </Fieldset>
                </div>

                <div className="col-12 mb-3">
                  <Fieldset legend="Work Experiences">
                    <div className="field m-0">
                      <DatatableItem
                        data={workExperience}
                        setData={setWorkExperience}
                        fields={{
                          companyName: 'Company',
                          numberOfYears: 'No. of Years',
                          title: 'Title',
                          roleSummary: 'Summary',
                          skills: 'Skills'
                        }}
                        className="inputfield w-full"
                      />
                    </div>
                  </Fieldset>
                </div>

                <div className="col-12 mb-3">
                  <Fieldset legend="Professional Certificates">
                    <div className="field m-0">
                      <DatatableItem
                        data={professionalCertificate}
                        setData={setProfessionalCertificate}
                        fields={{
                          title: 'Certificate',
                          issuerName: 'Issuer Name',
                          dateIssued: 'Date Issued'
                        }}
                        className="inputfield w-full"
                      />
                    </div>
                  </Fieldset>
                </div>

                <div className="col-12 mb-3">
                  <Fieldset legend="Social Links">
                    <div className="field m-0">
                      <DatatableItem
                        data={socialLink}
                        setData={setSocialLink}
                        fields={{
                          name: 'Platform',
                          link: 'Link'
                        }}
                        className="inputfield w-full"
                      />
                    </div>
                  </Fieldset>
                </div>
                <div className="col-12 flex justify-content-end align-items-end">
                    {resettable && <Button type="button" className="p-button-outlined p-button-secondary mr-3" label="Reset" icon="pi pi-refresh" onClick={() => handleReset(form)} disabled={pristine}></Button>}
                    <Button type="submit" label={submitButtonLabel} icon="pi pi-check"></Button>
                </div>
              </div>
            </form>
          )} />
      </Card >
    </div>
  )
}

export default ApplicationForm